import { Project } from '@/types';
import { getProjectLogoUrl } from '@/utils';

interface ProjectLogoProps {
  project: Project | null | undefined;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function ProjectLogo({ project, className = '', size = 'md' }: ProjectLogoProps) {
  const logoUrl = project?.logo ? getProjectLogoUrl(project.logo) : null;

  if (!logoUrl) {
    return null;
  }

  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-16 w-16',
  };

  return (
    <img
      src={logoUrl}
      alt={project?.title || 'Logo projet'}
      className={`${sizeClasses[size]} object-contain ${className}`}
      onError={(e) => {
        // Hide image if it fails to load
        (e.target as HTMLImageElement).style.display = 'none';
      }}
    />
  );
}
